export default function 
WarningIcon(props) {
  return (
    <svg
      width="80"
      {...props}
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.3182 59.1663L44.9253 15.833C43.9491 14.1663 42.2348 13.333 40.5205 13.333C38.8063 13.333 37.092 14.1663 36.0086 15.833L10.6277 59.1663C8.78364 62.4878 11.2171 66.6663 15.1325 66.6663H65.9182C69.8182 66.6663 72.2586 62.4997 70.3182 59.1663ZM16.3039 60.9521L40.4134 19.6187L64.7348 60.9521H16.3039ZM40.5205 49.6544C38.4539 49.6544 36.7777 51.3306 36.7777 53.3973C36.7777 55.464 38.4575 57.1402 40.5253 57.1402C42.5932 57.1402 44.2634 55.464 44.2634 53.3973C44.2586 51.333 42.592 49.6544 40.5205 49.6544ZM37.6634 31.4282V42.8568C37.6634 44.4402 38.9491 45.714 40.5205 45.714C42.092 45.714 43.3777 44.4342 43.3777 42.8568V31.4282C43.3777 29.8568 42.1039 28.5711 40.5205 28.5711C38.9372 28.5711 37.6634 29.8568 37.6634 31.4282Z"
        fill="#FFAE00"
      />
    </svg>
  )
}
